package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.CSSColor
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun AjouterBoutton(
    text: String,
    onClick: () -> Unit,
    isMobile: Boolean = false,
    isTablet: Boolean = false,
    color : CSSColorValue = Colors.White
) {
    Row(
        modifier = Modifier
            .border(1.px, LineStyle.Solid, Colors.Placeholder)
            .borderRadius(6.px)
            .padding(if (isMobile) 8.px else 12.px)
            .cursor(Cursor.Pointer)
            .onClick { onClick() },
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(5.px)
    ) {
        Image(
            src = if (color == Colors.White)"/add-plus.svg" else "/add_27dp_666666.svg",
            modifier = Modifier.size(if (isMobile) 18.px else 25.px)
        )
        SpanText(
            text = text,
            modifier = Modifier
                .fontSize(if (isMobile) 14.px else 18.px)
//                .color(color)
                .fontFamily(INTER)
        )
    }
}